var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Toggle',{model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}},[_c('span',{staticClass:"small"},[_vm._v(_vm._s(this.field.options.checkbox_label))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }